import React from 'react';
import PropTypes from 'prop-types';
import AccountBalanceWallet from '@material-ui/icons/AccountBalanceWallet';

import { paymentPropType } from '../../../../../types/subscription';
import { propTypes as i18nPropTypes } from '../../../../../hocs/intlEquipped';
import Divider from '../../../../Divider/Divider';
import ExpandableSection from '../../../../ExpandableSection';
import { formatCreditBalance } from '../helpers';
import DetailsHeader from '../DetailsHeader';

const CreditBalance = ({ payment, withDivider = false, theme, i18n }) => {
    const { formatMessage } = i18n;

    const creditBalance = formatCreditBalance({ payment, i18n });

    return creditBalance && (
        <div className={ theme.detailsContent }>
            { withDivider && <Divider theme={ theme } /> }
            <DetailsHeader text={ formatMessage('subscription.creditBalanceHeader') } />
            <ExpandableSection
                className={ theme.creditBalanceSection }
                mainContent={ (
                    <span className={ theme.creditBalanceMainSection }>
                        {formatMessage('subscription.creditBalanceSection')}
                    </span>
                ) }
                subContent={ creditBalance }
                icon={{ component: <AccountBalanceWallet className={ theme.detailIcon } /> }}
                theme={ theme }
            >
                <div className={ theme.creditBalanceDescription }>
                    {formatMessage('subscription.creditBalanceDescription')}
                </div>
            </ExpandableSection>
        </div>
    );
};

CreditBalance.propTypes = {
    payment: paymentPropType.isRequired,
    withDivider: PropTypes.bool,
    theme: PropTypes.shape({}),
    i18n: i18nPropTypes,
};

export default CreditBalance;
